import { render, staticRenderFns } from "./WarehouseDetail.vue?vue&type=template&id=2f702c91"
import script from "./WarehouseDetail.vue?vue&type=script&lang=js"
export * from "./WarehouseDetail.vue?vue&type=script&lang=js"
import style0 from "./WarehouseDetail.vue?vue&type=style&index=0&id=2f702c91&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports